export var toTuples = function (obj) {
    var r = [];
    var props = Object.keys(obj);
    var len = props.length;
    for (var q = 0; q < len; q++) {
        var k = props[q];
        var v = obj[k];
        r.push([k, v]);
    }
    return r;
};
//# sourceMappingURL=ObjectUtil.js.map